// RF-SLD20180014-0002 - Reconciliação mensal EDP
// Mapeamento das colunas dos ficheiros de cada fase para os campos da carga.
// É o único sítio a mudar quando os ficheiros reais mudarem de formato.
// Fase 1 — CSV das tarefas fechadas no Click (julho e agosto de 2026, workflow §6).
// O «Total na Factura c/IVA» é o cobrado ao cliente, por isso não serve para comparar
// valores: o Click não tem coluna de valor. Só contam as tarefas fechadas com a execução
// realizada; as canceladas e as de «Falta execução» ficam de fora (eram também a causa
// das ordens de serviço repetidas). Sem as colunas Estado / Motivo de Fecho, entram todas.
// Das restantes colunas (cliente, NIF, CUI, …) não se guarda nada.
const CLICK = {
    numeroParceiro: 'ID Ordem Serviço',
    tarefaId: 'ID Tarefa',
    tipoInstalacao: 'Tipo de Instalação',
    valor: null,
    incluir: o => (o['Estado'] === undefined || String(o['Estado']).trim() === 'Fechada') &&
        (o['Motivo de Fecho'] === undefined || String(o['Motivo de Fecho']).trim() === 'Execução Realizada'),
    guardar: ['ID Ordem Serviço', 'ID Tarefa', 'Tipo de Instalação', 'Estado', 'Motivo de Fecho', 'Data de Fecho']
};
// Fases 2 e 3 — ficheiro da EDP (modelo «IEP_maio2026 auto EDP corrigido.xlsx», folha IEP:
// Processo, Empresa, Distrito, Tipo de Instalação, Data Fecho, Valor a pagar, ...).
// Sem dados pessoais: guardam-se todas as colunas, que a exportação da fase 2 reproduz.
const EDP = {
    folha: 'IEP',
    numeroParceiro: 'Processo',
    tarefaId: null,
    tipoInstalacao: 'Tipo de Instalação',
    valor: 'Valor a pagar',
    bonificacao: 'Bonificação'
};
export const MAPEAMENTOS = {
    1: CLICK,
    2: EDP,
    3: EDP
};
export const NOME_FASE = {
    1: 'Click',
    2: 'EDP',
    3: 'Ficheiro final'
};
